<template>
  <div class="is-hidden-tablet">
    <table class="table is-fullwidth">
      <tbody>
        <tr>
          <section>
            <BCollapse
              class="card"
              animation="slide"
              v-for="(categories, index) in data"
              :key="index"
              :open="index == 0 ? true : false"
              @open="onOpenSection(categories.category)"
              @close="onCloseSection(categories.category)"
            >
              <div
                slot="trigger"
                slot-scope="props"
                class="columns is-gapless has-background-light	is-mobile is-vcentered custom-padding-collapse"
                role="button"
              >
                <div class="column is-1">
                  <a class="m-0 p-0 card-header-icon has-text-primary" v-if="categories.items">
                    <BIcon :icon="props.open ? 'minus-circle-outline' : 'plus-circle-outline'"> </BIcon>
                  </a>
                </div>
                <div class="column is-9">
                  <p class=" has-text-left has-text-grey title-font is-size-5 is-capitalized">
                    {{ categories.category }}
                  </p>
                </div>

                <div class="column is-2">
                  <div
                    class="has-background-primary has-text-light title box-title"
                    :class="{ 'hover-table-movil': (categories.totalAccumulated / gamesPlayed).toFixed(2) > 0 }"
                    @click="setOpenMediaFather((categories.totalAccumulated / gamesPlayed).toFixed(2), categories)"
                  >
                    {{ +(categories.totalAccumulated / gamesPlayed).toFixed(2) }}
                  </div>
                </div>
              </div>
              <div v-for="(item, index) in categories.items" :key="index" class="card-content padding-card">
                <div class="columns is-mobile is-vcentered is-gapless">
                  <div class="column is-8 is-offset-1">
                    <p class=" has-text-left has-text-grey is-4 subtitle-font is-capitalized">{{ item.category }}</p>
                  </div>
                  <div class="column is-3">
                    <div class="columns is-mobile  is-vcentered">
                      <div
                        :class="{ 'hover-table-movil': (item.totalAccumulated / gamesPlayed).toFixed(2) > 0 }"
                        class="column is-7 is-offset-2 subtitle has-background-light box-child "
                        @click="setOpenMediaChild((item.totalAccumulated / gamesPlayed).toFixed(2), item)"
                      >
                        {{ +(item.totalAccumulated / gamesPlayed).toFixed(2) }}
                      </div>
                      <a
                        class="column is-3 has-text-primary chevron-child"
                        @click="openModal(categories, item.category)"
                      >
                        <BIcon icon="chevron-right" class="custom-margin-right" size="is-medium"> </BIcon>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </BCollapse>
          </section>
        </tr>
      </tbody>
    </table>
    <DetailsDataMobileTable
      :item="selectedCategorie"
      :isActive="openDetailModal"
      :subcategorie="selectedSubcategorie"
      :displayData="displayData"
      @close="openDetailModal = false"
      @changeSubcategory="onChangeSubcategory"
    />
  </div>
</template>

<script>
import DetailsDataMobileTable from '@/components/Elements/DetailsDataMobileTable';
// import PieChartsPosessionTeam from '@/components/Elements/PieChartsPosessionTeam';
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
  name: 'DataMobileTable',
  components: {
    DetailsDataMobileTable,
    // PieChartsPosessionTeam,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    isSelectorHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDetailModal: false,
      selectedCategorie: {},
      selectedSubcategorie: '',
    };
  },
  computed: {
    ...mapGetters({
      getGamesPlayedByTeam: 'filterGeneral/getGamesPlayedByTeam',
    }),
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('playersGeneral', {
      playerId: 'playerId',
    }),
    ...mapState('filterGeneral', ['tournamentsForMediaPlayer']),
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    displayData() {
      let columns = [];
      this.columns.map(r => {
        if (r.name !== 'category' && r.display) {
          columns.push(r);
        }
      });
      return columns;
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    openModal(item, subcategorie) {
      this.selectedCategorie = item;
      this.selectedSubcategorie = subcategorie;
      this.openDetailModal = true;
      this.$emit('openSubcategory', subcategorie);
    },
    onOpenSection(sectionName) {
      this.$emit('showDetails', sectionName);
    },
    onCloseSection(sectionName) {
      this.$emit('hideDetails', sectionName);
    },
    onChangeSubcategory(subcategory) {
      this.$emit('changeSubcategory', subcategory);
    },
    getGeneralName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word, index) => {
          if (index === 0) {
            if (word.includes('.')) {
              accumulator.push(word);
            } else {
              const wordAux = word.toLowerCase().split('');
              wordAux[0] = wordAux[0].toUpperCase();
              accumulator.push(wordAux.join(''));
            }
          } else {
            accumulator.push(word.toLowerCase());
          }
          return accumulator;
        }, [])
        .join(' ');
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('vocan')) {
            wordAux = word.replace('vocan', 'voca');
          } else if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    setOpenMediaChild(value, item) {
      const generalName = this.getGeneralName(item.category);
      const singleName = this.getSingleName(generalName);
      if (value > 0) {
        let categoryIds = [];
        if (item.categoryIds) {
          categoryIds = categoryIds.concat(item.categoryIds);
        }
        if (item.rCategoryIds) {
          item.rCategoryIds.forEach(categoryId => {
            categoryIds.push(`${categoryId}_r`);
          });
        }
        const jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds,
          categorySingleName: singleName,
          mainSectionType: 1,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: [],
          advancedFilter: {
            playListTitle: generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: this.getSections,
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
          jsonConfig.playListType = 2;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
    setOpenMediaFather(value, props) {
      const generalName = this.getGeneralName(item.category);
      const singleName = this.getSingleName(generalName);
      if (value > 0) {
        let allCategories = [];
        if (!props.categoryIds && props.items) {
          for (const subcategory of props.items) {
            if (subcategory.categoryIds) {
              allCategories = allCategories.concat(subcategory.categoryIds);
            }
            if (subcategory.rCategoryIds) {
              subcategory.rCategoryIds.forEach(categoryId => {
                allCategories.push(`${categoryId}_r`);
              });
            }
          }
        } else {
          if (props.categoryIds) {
            allCategories = allCategories.concat(props.categoryIds);
          }
          if (props.rCategoryIds) {
            props.rCategoryIds.forEach(categoryId => {
              allCategories.push(`${categoryId}_r`);
            });
          }
        }

        const jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: allCategories,
          categorySingleName: singleName,
          mainSectionType: 1,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: [],
          advancedFilter: {
            playListTitle: generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: this.getSections,
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
          jsonConfig.playListType = 2;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
  },
};
</script>

<style scoped>
.hover-table-movil:hover {
  background: #cbee6b !important;
  opacity: 0.8 !important;
  cursor: pointer !important;
  color: #00a5ff !important;
}
.hover-table-movil {
  text-decoration: underline !important;
}
.custom-gap {
  margin: 3px 10px;
  padding: 3px 20px;
  border-radius: 8px;
}

.custom-padding-collapse {
  padding: 0px 10px;
}

.custom-margin-right {
  margin-right: 10px;
}

.card-content.padding-card {
  padding: 12px 20px;
  border-bottom: 1px ridge;
}

.box-child {
  border-radius: 10px;
  padding: 6px 8px;
  margin: 12px 0px;
  font-size: 3.71vw;
}

.box-title {
  border-radius: 10px;
  padding: 5px 0px;
  margin: 12px 5px;
  font-size: 4vw;
}

.chevron-child {
  margin: 0px;
  padding: 0px;
}

.columns {
  margin-left: 0px;
  margin-right: 0px;
}

.title-font {
  font-family: Avenir-Demi;
}

.subtitle-font {
  font-family: Avenir-Demi-Medium;
}

@media screen and (max-width: 425px) {
  .box-title {
    padding: 4px 0px;
    margin: 0px;
    font-size: 4.7vw;
  }

  .box-child {
    padding: 4px 0px;
    margin: 0px;
    font-size: 3.5vw !important;
  }

  .is-size-5 {
    font-size: 1rem !important;
  }
}
</style>
